import { CurrencyCode, LocaleCode } from '@appliedsystems/payments-core';

export const currencyMap = {
  [LocaleCode.en_US]: CurrencyCode.USD,
  [LocaleCode.en_GB]: CurrencyCode.GBP,
  [LocaleCode.en_CA]: CurrencyCode.CAD,
  [LocaleCode.fr_CA]: CurrencyCode.CAD,
};
